<template>
  <div class="gap-general strange">
    <SmallBanner
      :icon="'alarm'"
      :title="$t('stocks-trading-hours.title')"
      :description="$t('stocks-trading-hours.description')"
    />
    <div class="stocks-trading-hours-table margin-general">
      <p class="subTitle">{{ $t("stocks-trading-hours.subTitle") }}</p>
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>{{ $t("stocks-trading-hours.product") }}</th>
              <th>{{ $t("stocks-trading-hours.trading") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in products" :key="index">
              <td class="product">{{ item.name }}</td>
              <td class="hour" :class="item.red ? 'red' : ''">
                {{ item.tradingHours }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="disclaimer">
        {{ $t("stocks-trading-hours.disclaimer") }}
      </div>
    </div>
    <client-only>
      <LazyInvestment
        class="investment var-invest-two"
        :label="'forex-contract-specs.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'forex-contract-specs.btn'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import SmallBanner from "~/components/SmallBanner.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();
const { getExternalUrl } = useExternalUrl();
const title = t("seo.trading-conditions.stocks.trading-hours.title");
const description = t(
  "seo.trading-conditions.stocks.trading-hours.description"
);

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
});

const products = [
  {
    name: "Pre-market trading",
    tradingHours: "4:00 to 9:30 (Mon- Fri)",
  },
  {
    name: "Regular trading",
    tradingHours: "9;30 to 16:00 (Mon- Fri)",
  },
  {
    name: "Post-market trading",
    tradingHours: "16:00 to 20:00 (Mon- Fri)",
  },
  {
    name: "Closed market",
    tradingHours: "20:00 to 4:00 (Mon- Fri) 4:00 to 4:00 (Sat- Sun)",
  },
];
</script>
